import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useOrganizationRoutes} from 'organization/OrganizationRoutes'
import styled from 'styled-components'
import {useOrganizationEventsList} from 'organization/ListEvents/providers/OrganizationEventsListProvider'
import {ListItem} from 'organization/ListEvents/ListItem'
import OrganizationPage from 'organization/theme/OrganizationPage'
import {useI18n} from 'i18n/I18nContext'

export const EventsList = () => {
  const {t} = useI18n()
  const routes = useOrganizationRoutes()
  const {events} = useOrganizationEventsList()

  const breadcrumButtons = (
    <div className="breadcrum__button" style={{display: 'flex', gap: 15}}>
      <LocalLink
        to={routes.event.create.root}
        className="breadcrum__btn event__popup-active"
      >
        {t('orgList.createEvent')}
        <i className="fa-regular fa-plus"></i>
      </LocalLink>
    </div>
  )

  return (
    <OrganizationPage>
      <div className="row pl-30 pb-30 pr-30">
        <BreadcrumMenu
          title={t('orgList.myEvents')}
          buttons={breadcrumButtons}
        />

        <div className="row g-20">
          {events.length > 0 &&
            events?.map((event) => <ListItem event={event} />)}
          {events.length <= 0 && (
            <NoEventsMessage>{t('orgList.noEvents')}</NoEventsMessage>
          )}
        </div>
      </div>
    </OrganizationPage>
  )
}

const NoEventsMessage = styled.div`
  text-align: center;
`
